export default __webpack_public_path__ + "static/media/soRekt_light.dd9434de.svg";